import { useBlogContext } from '../../../context/BlogContext';
import CustomTable from '../../Custom/Table';
import useBlogTable from './useBlogTable';

const BlogTable = () => {

    const { columns } = useBlogTable()
    const {blogs} = useBlogContext()

    const blogsDate = [...blogs].filter(blog => blog.activo).sort((a, b) => new Date(b.fechaRegistro).getTime() - new Date(a.fechaRegistro).getTime());
    

    return <CustomTable rows={blogsDate} columns={columns} />
    
}

export default BlogTable